import { render, staticRenderFns } from "./sustainability.vue?vue&type=template&id=d77a6318&"
import script from "./sustainability.vue?vue&type=script&lang=js&"
export * from "./sustainability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports